module.exports = __webpack_public_path__ + "img/303.1413a8f7.png";